import type { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router';

import { FullPageLoader } from '@/components/FullPage';

import { useAuth } from './context';
import { postLoginPath } from './redirect';

/** Pages for signed-out visitors only (`/login`): an active session goes straight to the app. */
export function GuestOnly({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === 'loading') return <FullPageLoader />;
  if (status === 'authenticated') return <Navigate to={postLoginPath(location.state)} replace />;
  return children;
}
